import notfoundLottie from "assets/files/notfound-lottie.json";
import { SEO } from "components/utils/Seo";
import Lottie from "lottie-react";

const IndexPage = () => (
  <>
    <SEO title="Not Found" />
    <Lottie
      animationData={notfoundLottie}
      style={{ width: "100vw", height: "100vh", overflow: "hidden" }}
    />
  </>
);

export default IndexPage;
